import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { v2MenuItemSizeClass } from '@onevision-resources/design-theme';
import { LucideIcon } from 'lucide-react';

export interface OptionSwitchMenuOption<OptionId> {
  value: OptionId;
  label: string;
  icon: LucideIcon;
}

interface OptionSwitchMenuProps<OptionId> {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  options: OptionSwitchMenuOption<OptionId>[];
  selectedValue?: OptionId;
  onSelect: (value: OptionId) => void;
}

export const OptionSwitchMenu = <OptionId,>({
  anchorEl,
  onClose,
  options,
  selectedValue,
  onSelect,
}: OptionSwitchMenuProps<OptionId>) => (
  <Menu
    anchorEl={anchorEl}
    open={Boolean(anchorEl)}
    onClose={onClose}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'left',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'left',
    }}
  >
    {options.map((option) => {
      const OptionIcon = option.icon;

      return (
        <MenuItem
          className={v2MenuItemSizeClass.large}
          selected={option.value === selectedValue}
          key={option.label}
          onClick={() => onSelect(option.value)}
        >
          <ListItemIcon>
            <OptionIcon />
          </ListItemIcon>
          <ListItemText>{option.label}</ListItemText>
        </MenuItem>
      );
    })}
  </Menu>
);
